import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const currentLocale = i18n.language;

    const langs = ["nl", "fr", "en"] as const;

    const [indicator, setIndicator] = useState<{
        left: number;
        width: number;
    } | null>(null);
    const itemRefs = useRef<Record<string, HTMLButtonElement | null>>({});
    const containerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const measure = () => {
            const activeItem = itemRefs.current[currentLocale];

            if (!activeItem) {
                return;
            }

            setIndicator({
                left: activeItem.offsetLeft,
                width: activeItem.offsetWidth,
            });
        };

        measure();
        const container = containerRef.current;

        if (!container || typeof ResizeObserver === "undefined") {
            return;
        }

        const observer = new ResizeObserver(measure);
        observer.observe(container);

        return () => observer.disconnect();
    }, [currentLocale]);

    return (
        <div
            ref={containerRef}
            className="relative mt-2 mx-auto w-fit flex items-center border border-white/20 rounded-full p-1 bg-gray-500/40"
        >
            {indicator && (
                <span
                    aria-hidden="true"
                    className="absolute inset-y-1 left-0 rounded-full bg-off-white-100 transition-[transform,width] duration-300 ease-out"
                    style={{
                        transform: `translateX(${indicator.left}px)`,
                        width: indicator.width,
                    }}
                />
            )}
            {langs &&
                langs.length > 0 &&
                langs?.map((lng) => (
                    <button
                        key={lng}
                        type="button"
                        ref={(el) => {
                            itemRefs.current[lng] = el;
                        }}
                        onClick={() => changeLanguage(lng)}
                        className={`relative z-10 px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
                            currentLocale === lng
                                ? "text-black"
                                : "text-white/60 hover:text-white"
                        }`}
                    >
                        {lng.toUpperCase()}
                    </button>
                ))}
        </div>
    );
};
